import { useState } from 'react';

export function useDropdown() {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        event?.stopPropagation();
        setAnchorEl(null);
    };

    const closeMenu = () => setAnchorEl(null);

    return { anchorEl, open, handleOpen, handleClose, closeMenu };
}
